<template>
    <div class="card-body">
        <div class="card-title text-white">
            Client Users
        </div>
        <b-row class="pt-2">
            <b-col cols="12">
                <div class="ccb_button mb-3">
                    <div class="ccb_button_text" @click="setAdministrationView('administration')"  >
                        <span :class="administration_view == 'administration' ? 'activeBtn' : ''">Administration</span>
                    </div>
                </div>
            </b-col>
            <b-col cols="12">
                <div class="ccb_button mb-3">
                    <div class="ccb_button_text" @click="setAdministrationView('workflow')"  >
                        <span :class="administration_view == 'workflow' ? 'activeBtn' : ''">Workflows</span>
                    </div>
                </div>
            </b-col>

            <b-col cols="12">
                <div class="ccb_button mb-3">
                    <div class="ccb_button_text" @click="setAdministrationView('audit_logs')"  >
                        <span :class="administration_view == 'audit_logs' ? 'activeBtn' : ''">Audit Logs</span>
                    </div>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { clientAdminMenuComputed, clientAdminMenuMethods} from '@/state/helpers'
export default {
    data:() => ({

    }),
    computed:{
        ...clientAdminMenuComputed,
    },
    methods:{
        ...clientAdminMenuMethods,
    },
    mounted(){},
}
</script>

<style>

</style>